// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { DeviceTrafficMessage, unionToDeviceTrafficMessage, unionListToDeviceTrafficMessage } from './device-traffic-message';
import { ElevatorTrafficMessage, ElevatorTrafficMessageT } from './elevator-traffic-message';
import { EscalatorTrafficMessage, EscalatorTrafficMessageT } from './escalator-traffic-message';


export class TrafficMessage implements flatbuffers.IUnpackableObject<TrafficMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):TrafficMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsTrafficMessage(bb:flatbuffers.ByteBuffer, obj?:TrafficMessage):TrafficMessage {
  return (obj || new TrafficMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsTrafficMessage(bb:flatbuffers.ByteBuffer, obj?:TrafficMessage):TrafficMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new TrafficMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

messageType():DeviceTrafficMessage {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : DeviceTrafficMessage.NONE;
}

message<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

static startTrafficMessage(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addMessageType(builder:flatbuffers.Builder, messageType:DeviceTrafficMessage) {
  builder.addFieldInt8(0, messageType, DeviceTrafficMessage.NONE);
}

static addMessage(builder:flatbuffers.Builder, messageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, messageOffset, 0);
}

static endTrafficMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 6) // message
  return offset;
}

static createTrafficMessage(builder:flatbuffers.Builder, messageType:DeviceTrafficMessage, messageOffset:flatbuffers.Offset):flatbuffers.Offset {
  TrafficMessage.startTrafficMessage(builder);
  TrafficMessage.addMessageType(builder, messageType);
  TrafficMessage.addMessage(builder, messageOffset);
  return TrafficMessage.endTrafficMessage(builder);
}

unpack(): TrafficMessageT {
  return new TrafficMessageT(
    this.messageType(),
    (() => {
      const temp = unionToDeviceTrafficMessage(this.messageType(), this.message.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })()
  );
}


unpackTo(_o: TrafficMessageT): void {
  _o.messageType = this.messageType();
  _o.message = (() => {
      const temp = unionToDeviceTrafficMessage(this.messageType(), this.message.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
}
}

export class TrafficMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public messageType: DeviceTrafficMessage = DeviceTrafficMessage.NONE,
  public message: ElevatorTrafficMessageT|EscalatorTrafficMessageT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const message = builder.createObjectOffset(this.message);

  return TrafficMessage.createTrafficMessage(builder,
    this.messageType,
    message
  );
}
}
